var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyToClipboardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.026 9.8c0 .135-.11.245-.245.245h-1.839V4.297c0-.63-.511-1.14-1.141-1.141H4.053v-1.84c0-.134.11-.244.245-.244h8.483c.136 0 .245.11.245.245V9.8zm-2.981 2.981c0 .135-.11.245-.244.245H1.316c-.134 0-.243-.11-.243-.245V4.297c0-.135.109-.244.243-.244h8.485c.134 0 .244.11.244.244v8.484zM12.78.175H4.298c-.631 0-1.142.511-1.143 1.142v1.839H1.316c-.63 0-1.14.51-1.14 1.141v8.484c0 .63.51 1.142 1.14 1.142h8.485c.63 0 1.141-.512 1.141-1.142v-1.839h1.839c.63 0 1.142-.511 1.142-1.141V1.317c0-.631-.511-1.141-1.142-1.142z",
    transform: "translate(-1174 -466) translate(640 280) translate(40 175) translate(494 11)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M13.026 9.8c0 .135-.11.245-.245.245h-1.839V4.297c0-.63-.511-1.14-1.141-1.141H4.053v-1.84c0-.134.11-.244.245-.244h8.483c.136 0 .245.11.245.245V9.8zm-2.981 2.981c0 .135-.11.245-.244.245H1.316c-.134 0-.243-.11-.243-.245V4.297c0-.135.109-.244.243-.244h8.485c.134 0 .244.11.244.244v8.484zM12.78.175H4.298c-.631 0-1.142.511-1.143 1.142v1.839H1.316c-.63 0-1.14.51-1.14 1.141v8.484c0 .63.51 1.142 1.14 1.142h8.485c.63 0 1.141-.512 1.141-1.142v-1.839h1.839c.63 0 1.142-.511 1.142-1.141V1.317c0-.631-.511-1.141-1.142-1.142z",
    transform: "translate(-1174 -466) translate(640 280) translate(40 175) translate(494 11)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboardNew);
export default __webpack_public_path__ + "static/media/copy-to-clipboard-new.cbbe580364af236dc606ded4deea21e0.svg";
export { ForwardRef as ReactComponent };